export const FORMAT_OPTIONS_PARTICIPACAO_PERCENTUAL = {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3,
} as const

export const FORMAT_OPTIONS_PARTICIPACAO_MONETARIO = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
} as const
